import {
	ContentRelatedTo,
	ContentRelatedWork,
} from '@nexspec/warehouse-shared-types/dist/titles/TitleMetadata/ContentRelatedTo';
import { CommonReadonly, TitleFull } from '@warehouse/title/core';

export interface ContentRelatedToRelationshipEditorAdapterInput {
	childUuid: string;
	contentRelatedTo: ContentRelatedTo[];
	childData: TitleFull;
	parentData: TitleFull;
}

export interface ContentRelatedToRelationshipEditorAdapterOutput {
	childTitle: CommonReadonly;
	parentTitle: CommonReadonly;
	primary: boolean;
}

export function adapt({
	childUuid,
	contentRelatedTo,
	childData,
	parentData,
}: ContentRelatedToRelationshipEditorAdapterInput): ContentRelatedToRelationshipEditorAdapterOutput {
	const workItem = findContentRelatedToWork(contentRelatedTo, childUuid);
	if (!workItem) {
		return {
			primary: false,
			childTitle: childData.readonly,
			parentTitle: parentData.readonly,
		};
	}

	return {
		childTitle: childData.readonly,
		parentTitle: parentData.readonly,
		primary: workItem?.primary === true,
	};
}

export function updateWorkItemsDelete(
	childUuidToDelete: string,
	contentRelatedTo: ContentRelatedTo[],
): ContentRelatedTo[] {
	return contentRelatedTo
		.map((contentRelated) => ({
			...contentRelated,
			work: contentRelated.work.filter((work) => work.contentId !== childUuidToDelete),
		}))
		.filter((contentRelated) => contentRelated.work.length > 0);
}

function findContentRelatedToWork(
	contentRelatedTo: ContentRelatedTo[],
	childUuid: string,
): ContentRelatedWork | undefined {
	return contentRelatedTo.flatMap((contentRelated) => contentRelated.work).find((work) => work.contentId === childUuid);
}

export function updatePrimaryInWorkItem(
	primary: boolean,
	childUuid: string,
	contentRelatedTo: ContentRelatedTo[],
): ContentRelatedTo[] {
	return contentRelatedTo.map((contentRelated) => {
		if (contentRelated.work.some((work) => work.contentId === childUuid)) {
			return {
				...contentRelated,
				work: contentRelated.work.map((work) => (work.contentId === childUuid ? { ...work, primary } : work)),
			};
		}
		return contentRelated;
	});
}
